import { forwardRef, useEffect, useImperativeHandle, useState, useMemo } from 'react'
import useTransferData from 'core/controller/transfer/transfer'
import Button from '@/components/discardedComponent/Button'
import { Select, Tooltip } from 'antd'
import styles from './styled.module.scss'
import { useLocale } from 'core/components/Locale'
import { useHCRouter } from '@/components/HCNextLink'
import useUtils from 'core/utils/useUtils'
import cls from 'classnames'
import NoData from '@/components/NoData'
import { toNonExponential, spliceDecimal } from 'core/utils/index'
import Modal from '@/components/Modal'
import Ellipsis from '../Ellipsis'

// eslint-disable-next-line react/display-name
export default forwardRef(
  (_props: { source: string | number; target: string | number; coinId?: null | number; onClose?: () => void }, ref) => {
    const t = useLocale()
    const router = useHCRouter()
    const [rechargeModalVisible, setRechargeModalVisible] = useState(false)
    const localeMap = {
      accountTypeList: [
        // 账户类型列表
        { value: 2, label: t('accountCoinTrade_005') },
        { value: 6, label: t('marginTrade_081') },
        { value: 7, label: t('marginTrade_082') },
        { value: 5, label: t('contract_370') },
        { value: 3, label: t('hotcoinWeb_v9_C2CAccount') },
        { value: 8, label: t('contract_371') },
      ],
      amountNonZero: t('accountCoinTrade_082'), //划转数量不能为空和0
      notEnoughBalance: t('accountCoinTrade_083'), //可用余额不足
    }
    const {
      coinId,
      setCoinId,
      coinList,
      currentCoin,
      source,
      setSource,
      target,
      setTarget,
      amount,
      setAmount,
      tradeId,
      setTradeId,
      tradeList,
      sourceList = [],
      targetList = [],
      walletInfo,
      type,
      onTransfer,
      reverseAccount,
      totalBalance,
      filterCoin,
    } = useTransferData(localeMap)

    const { rateFilter } = useUtils()
    const sourceListOptions = sourceList.map((item) => ({
      ...item,
      label: <Ellipsis title={item.label} />,
    }))

    /**
     * 查看划转记录
     */
    const toRecord = () => {
      router.push(`/orderHome/transferRecord?source=${source}&target=${target}`)
    }

    /**
     * 激活账户
     */
    const toActive = (account) => {
      if (account.value == 6 || account.value == 7) {
        // TODO 未开通杠杆
      }
      if (account.value == 5 || account.value == 8) {
        // TODO 未开通合约
      }
    }

    // 初始化传递进来的值
    useEffect(() => {
      if (_props?.source) {
        setSource(_props.source)
      }
      if (_props?.target) {
        setTarget(_props.target)
      }
    }, [])

    useEffect(() => {
      const defaultCoinId = 52
      if (_props?.coinId && coinList?.length) {
        const coinExists = coinList.some((coin) => coin.value === _props.coinId)
        setCoinId(coinExists ? _props.coinId : defaultCoinId)
      } else {
        setCoinId(defaultCoinId)
      }
    }, [coinList])

    useImperativeHandle(ref, () => {
      return {
        onTransfer,
        toRecord,
        source,
        target,
        walletInfo,
      }
    }, [currentCoin, amount, coinId, type, source, target, walletInfo])

    const amountKeyUp = (e) => {
      const value = e.target.value.toString().replace(/[^\d\.]/gi, '')
      const total = toNonExponential(Math.min(walletInfo?.todayAvailableLimit, totalBalance))
      if (value && Number(value) > Number(total)) {
        allBalance()
      } else {
        setAmount(spliceDecimal(value, currentCoin.transferPrecision))
      }
    }
    // 数量 全部
    const allBalance = () => {
      const amount = toNonExponential(Math.min(totalBalance, walletInfo?.todayAvailableLimit))
      setAmount(amount)
    }

    const rechargeItems = useMemo(() => {
      return [
        {
          path: `/assetManagement/topup?name=${currentCoin?.coinId}`,
          iconClassName: 'topUp',
          title: t('home_v11_TopUp'),
          subTitle: t('hotcoinWeb_v9_TransferDigitalCurrencyTo'),
        },
        {
          path: `/c2c/trade`,
          iconClassName: 'c2c',
          title: t('home_v9_C2CBuyCoins'),
          subTitle: t('home_v9_FastAndConvenientNo'),
        },
        {
          path: `/c2c/trade/creditCardIndex`,
          iconClassName: 'credit',
          title: t('home_v9_BuyCoinsWithCredit'),
          subTitle: t('home_v9_VisaMasterCard_1'),
        },
      ]
    }, [currentCoin])

    const optionRender = (option, config) => {
      return (
        <div className="flex justify-content-space-between">
          <span className="w-0 flex-auto">{option.label}</span>
          {config.isSource &&
            (option.data.sourceActivated ? (
              <div className="text-right">
                {t('otcAdvertise_037')}
                <span className="px-1">{option.data.available}</span>
                {currentCoin && currentCoin.shortName}
              </div>
            ) : (
              <div>
                <span onClick={() => toActive(option.data)}>{t('home_v9_Inactivated')}</span>
              </div>
            ))}
          {config.isTarget && !option.data.sourceActivated && (
            <div>
              <span className="c4 f12 " onClick={() => toActive(option.data)}>
                {t('home_v9_Inactivated')}
              </span>
            </div>
          )}
          {config.isTarget && !option.data.targetActivated && (
            <div>
              <span className="c4 f12 " onClick={() => toActive(option.data)}>
                {t('home_v9_Inactivated')}
              </span>
            </div>
          )}
        </div>
      )
    }

    return (
      <>
        <Modal open={rechargeModalVisible} onClose={() => setRechargeModalVisible(false)} title={t('home_v11_TopUp')}>
          <div className={styles.rechargeContent}>
            {rechargeItems.map((item, indexKey: number) => (
              <div
                key={indexKey}
                className={styles.rechargeItem}
                onClick={() => {
                  router.push(item.path)
                  _props.onClose?.()
                }}
              >
                <div className={cls(styles[item.iconClassName], styles.coverIcon)}></div>
                <div>
                  <div className="f14">{item.title}</div>
                  <div className="f12 c9">{item.subTitle}</div>
                </div>
              </div>
            ))}
          </div>
        </Modal>
        <div className={styles.transferMain}>
          <div className={styles.transferBody}>
            <div className={styles.transferIcon} onClick={reverseAccount}></div>
            <div className={cls(styles.transferFromTo)}>
              <p>{t('contractOpen_dialog_004')}</p>
              <p>{t('contractOpen_dialog_005')}</p>
            </div>
            <div className={styles.transferAccount}>
              {/* 来源账户 */}
              <Select
                variant="borderless"
                defaultValue={source}
                value={source}
                style={{ width: '100%', marginTop: '-6px' }}
                options={sourceListOptions}
                optionRender={(option) => optionRender(option, { isSource: true })}
                onChange={(value) => {
                  setSource(value)
                  setAmount('')
                  if (value === 7 && tradeList?.length) {
                    const firstValidTrade = tradeList.find((item) => !item.disabled)
                    if (firstValidTrade?.tradeId) {
                      setTradeId(firstValidTrade.tradeId)
                    }
                  }
                }}
              />
              {/* 目标账户 */}
              <Select
                variant="borderless"
                defaultValue={target}
                value={target}
                style={{ width: '100%', marginBottom: '-6px' }}
                options={targetList}
                optionRender={(option) => optionRender(option, { isTarget: true })}
                onChange={(value) => {
                  setTarget(value)
                  setAmount('')
                  if (value === 7 && tradeList?.length) {
                    const firstValidTrade = tradeList.find((item) => !item.disabled)
                    if (firstValidTrade?.tradeId) {
                      setTradeId(firstValidTrade.tradeId)
                    }
                  }
                }}
              />
            </div>
          </div>

          {/* 交易对 */}
          {(+source === 7 || +target === 7) && (
            <div>
              <div className={styles.coinType}>{t('market_006')}</div>
              <div className={styles.selectBox}>
                <Select
                  value={tradeId}
                  style={{ width: '100%' }}
                  variant="borderless"
                  notFoundContent={<NoData />}
                  options={tradeList}
                  onChange={setTradeId}
                  optionRender={(option) => (
                    <div className="flex justify-between">
                      <span>{option.data.label}</span>
                      {option.data.disabled && <span>{t('marginTrade_019')}</span>}
                    </div>
                  )}
                />
              </div>
            </div>
          )}

          {/* 币种 */}
          <div>
            <div className={styles.coinType}>{t('contractOpen_dialog_002')}</div>
            <div className={styles.selectBox}>
              {currentCoin && <img className={styles.selectBoxImg} src={currentCoin?.webLogo} alt="" />}
              <Select
                defaultValue={coinId}
                value={coinId}
                style={{ width: '100%' }}
                variant="borderless"
                placeholder={t('area_code_001')}
                options={coinList}
                notFoundContent={<NoData />}
                onChange={(value) => {
                  setCoinId(value)
                  setAmount('')
                }}
                showSearch
                filterOption={filterCoin}
                popupClassName={styles.coinPopup}
                optionRender={(option) => (
                  <div className={cls(styles.coinItem)}>
                    <div className="left flex items-center">
                      <img className="w-6 h-6 mr-2" src={option.data?.webLogo} alt="" />
                      <div className="left-right">
                        <div className={cls('f14 ex-fontWeight', coinId === option.data.coinId && 'c12')}>
                          {option.data.shortName}
                        </div>
                        <div className="f12 c9">{option.data.name}</div>
                      </div>
                    </div>
                    {!option.data.transferOutAble || !option.data.transferInAble ? (
                      <span className="c8 f12 ml-2.5">{t('marginTrade_019')}</span>
                    ) : (
                      <div className="right text-right">
                        <div className={cls('f14', coinId === option.data.coinId && 'c12')}>
                          {option.data.available || 0}
                        </div>
                        <div className="f12 c9">
                          {/* TODO symbol */}
                          ≈¥{/*{currentCurrency?.symbol}*/}
                          {rateFilter(option.data.availableCny)}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>

          {/* 数量 */}
          <div>
            <div className={styles.coinFlexBox}>
              <div className={styles.coinNum}>{t('accountCoinTrade_033')}</div>
              <div className={styles.coinText}>
                <span>{t('accountCoinTrade_012')}：</span>
                <span>
                  {currentCoin?.available || 0} {currentCoin?.shortName}
                </span>
              </div>
            </div>
            <div className={styles.selectBox}>
              <div className={styles.selectBoxInput}>
                <input
                  autoComplete="off"
                  name="amount"
                  type="text"
                  placeholder={t('contractExchange_025')}
                  max={isNaN(Number(currentCoin?.available)) ? 0 : Number(currentCoin?.available)}
                  min={0}
                  value={amount}
                  onChange={amountKeyUp}
                />
              </div>
              <div className={styles.selectBoxCoinType}>
                <div>{currentCoin?.shortName}</div>
                <div></div>
                <div onClick={allBalance}>{t('accountCoinTrade_076')}</div>
              </div>
            </div>
            <div className={styles.coinText1}>
              <span>{(t('accountCoinTrade_195') as string).replace('$[total]', '')}</span>
              <span>
                {walletInfo?.todayAvailableLimit} {currentCoin?.shortName}
              </span>
              {Number(walletInfo?.available) === 0 && (
                <span className={styles.rechargeMessage}>
                  {t('hotcoinWeb_v9_no_assets_tips', {
                    color_0: {
                      tag: 'span',
                      props: {
                        className: 'c12 cursor-pointer',
                        onClick: () => {
                          // TODO 充值弹窗
                          setRechargeModalVisible(true)
                        },
                      },
                    },
                  })}
                </span>
              )}
            </div>
          </div>

          {/* 头部查看记录 */}
          <Button type="outline" size="s" onClick={toRecord}>
            {t('home_v9_ViewRecord')}
          </Button>
        </div>
      </>
    )
  }
)
